import { render, staticRenderFns } from "./mr_widget_closed.vue?vue&type=template&id=0fa4570d&"
import script from "./mr_widget_closed.vue?vue&type=script&lang=js&"
export * from "./mr_widget_closed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "mr_widget_closed.vue"
export default component.exports